<p-toolbar
    id="app-header"
    class="app-header"
    [class.sidebar-expanded]="!isSidebarCollapsed()"
    [class.impersonation]="impersonatedUser() !== null">
    <header class="no-print">
        <div class="p-toolbar-group-left screen-lg">
            <div class="row">
                @if (!shouldHideUserInfo() && currentUser()?.firstName) {
                    <div id="header-welcome-message">
                        {{ welcomeMessage() | translate }},
                        <span id="header-user-first-name"
                            >{{ currentUser()?.firstName ? currentUser()?.firstName : null }}!</span
                        >
                    </div>
                } @else {
                    <div id="header-welcome-message">{{ welcomeMessage() | translate }}!</div>
                }

                @if (impersonatedUser()) {
                    <p class="impersonation-warning">
                        (<deco-icon [iconClass]="'fa-solid fa-triangle-exclamation'" [color]="'#a73030'" />
                        {{ 'impersonate.headerMessage' | translate }} -
                        <a
                            id="stop-impersonation-button"
                            tabindex="0"
                            role="button"
                            aria-label="Stop impersonate"
                            (click)="stopImpersonation()"
                            (keyup.enter)="stopImpersonation()"
                            >stop</a
                        >)
                    </p>
                }

                @if (!shouldHideUserInfo() && currentUser()?.laboratoryName && currentUser()?.laboratoryName != '') {
                    <span class="lab-container">
                        <deco-icon [iconClass]="'fa-solid fa-pipe'" />
                        <p id="header-user-group">{{ currentUser()?.laboratoryName }}</p>
                    </span>
                }
            </div>

            @if (impersonatedUser()) {
                <p class="impersonated-user-email">({{ impersonatedUser()?.email }})</p>
            }
        </div>

        <div class="p-toolbar-group-left screen-sm">
            <div id="sidebar-header-logo">
                <span style="position: relative; width: 40px; height: 40px">
                    <a [routerLink]="'/'" aria-label="Go to dashboard">
                        <img
                            [ngSrc]="'assets/images/app-logo.svg'"
                            fill
                            id="app-logo"
                            alt="The application logo and redirects to the dashboard" />
                    </a>
                </span>
                <div>
                    <h1 id="app-title-header">QuickOrder</h1>
                    <h2 id="app-subtitle-header">Transnetyx</h2>
                </div>
            </div>
        </div>

        <div class="no-print">
            <app-toolbar [hideUserInfo]="shouldHideUserInfo()"></app-toolbar>
        </div>
    </header>
</p-toolbar>
